import {RequestOptions} from '@angular/http';
import {AppRequestOptionArgs} from './AppRequestOptionArgs';

export class AppRequestOptions extends RequestOptions implements AppRequestOptionArgs {

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/http-client/AppRequestOptions.ts